module.exports = __webpack_public_path__ + "img/down.7c159688.jpg";